"use strict";

import "./Spinner.css";
import React from "react";

export default class Spinner extends React.Component {
	
	render() {
		return (
			<div className="Spinner">
				<svg className="circular" viewBox="25 25 50 50">
				  <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" stroke-miterlimit="10"/>
				</svg>
			  </div>
		);
	}
	
}


// WEBPACK FOOTER //
// ./~/vwa/components/Spinner/Spinner.jsx